const readFile = file => new Promise(resolve => {
	const reader = new FileReader();
  reader.addEventListener('load', e => resolve(e.target.result));
	reader.readAsText(file);
});

export default readFile;
